import { StrictMode } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./locales/i18n";
import { Provider } from "react-redux";
import Store from "./Redux/Store";
import { BrowserRouter } from "react-router-dom";

import "normalize-package-data";
// import '@fortawesome/free-solid-svg-icons'

ReactDOM.render(
  <StrictMode>
    <Provider store={Store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
